/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gold_Wry_Mole_KickInputs */

const en_gold_wry_mole_kick = /** @type {(inputs: Gold_Wry_Mole_KickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail or employee number is required for identification`)
};

const de_gold_wry_mole_kick = /** @type {(inputs: Gold_Wry_Mole_KickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail oder Personalnummer wird für die Identifikation benötigt.`)
};

/**
* | output |
* | --- |
* | "E-mail or employee number is required for identification" |
*
* @param {Gold_Wry_Mole_KickInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gold_wry_mole_kick = /** @type {((inputs?: Gold_Wry_Mole_KickInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gold_Wry_Mole_KickInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gold_wry_mole_kick(inputs)
	return de_gold_wry_mole_kick(inputs)
});